<template>
    <div ref="container" style="height: 100%" />
</template>

<script lang="ts">
import Vue from "vue";
// Importado para ativar o augmentation de $route e $router no arquivo
import "vue-router";

// Interface local — não importa tipos de src/react/ para evitar conflito
// com o namespace JSX global do Vue (shims-tsx.d.ts).
interface ReactHandle {
    unmount(): void;
    render(page: "lista" | "edicao", id?: number, onNavigate?: (path: string) => void): void;
}

export default Vue.extend({
    name: "ReactMountHome",

    data(): { handle: ReactHandle | null; alive: boolean } {
        return { handle: null, alive: false };
    },

    async mounted() {
        this.alive = true;
        // @ts-ignore — src/react/ é compilado pelo Babel; os tipos não estão
        // no tsconfig do Vue de propósito para evitar conflitos com JSX global.
        const { mountHomeApp } = await import(
            /* webpackChunkName: "react-home" */ "@/react/mountHome"
        );
        if (!this.alive) {
            return;
        }
        const container = this.$refs.container as HTMLElement | null;
        if (!container) {
            return;
        }
        this.handle = (mountHomeApp as (el: HTMLElement) => ReactHandle)(container);
        // Tela única: page/id são ignorados pelo app; o onNavigate leva das
        // opções da home para as demais telas (Vue) via Vue Router.
        this.handle.render("lista", undefined, (path: string) => {
            this.$router.push(path);
        });
    },

    beforeDestroy() {
        this.alive = false;
        this.handle?.unmount();
        this.handle = null;
    },
});
</script>
